import { gql } from '@apollo/client';

export const ScheduledChangesForEntitlementV2 = gql`
  fragment ScheduledChangesForEntitlementV2 on ScheduledChanges {
    nextChangeTimestamp
    subscriptionScheduleAction
    transactionAccountId
    invoiceGroupId
    offering {
      ...OfferingFieldsToCompare
    }
    pricingPlan {
      ...PricingPlanFieldsToCompare
    }
    promotions {
      benefits {
        value
        benefitType
        subBenefitType
        duration
        iterations
        customisable {
          value {
            type
            lowerBound
            upperBound
          }
          iterations {
            type
            lowerBound
            upperBound
          }
          duration
        }
      }
      promotionInstanceId
      promotionWindow {
        startTime
        endTime
      }
      id
      promotionCode
      status
      rule
      title
      type
      pricingType
      cycleInterval
      applicationReason {
        id
        readableName
        customisable {
          id {
            type
            anyOf {
              readableName
              id
            }
          }
        }
      }
      isPromotionCustomisable
    }
    chargeQuantities {
      chargeElement
      quantity
    }
    scheduledBillingInvoiceGroupId
  }
`;

export const OfferingFieldsToCompare = gql`
  fragment OfferingFieldsToCompare on Offering {
    id
    name
  }
`;

export const PricingPlanFieldsToCompare = gql`
  fragment PricingPlanFieldsToCompare on PricingPlan {
    type
    billingFrequency
  }
`;
